import React, { Component } from 'react';
import { Menu, Dropdown, Icon, Button } from 'antd';
import { withRouter, Link } from 'react-router-dom';
import './churchSelector.css';
import { revivalPhaseCountdown } from "../../utilities/churchRevival";
import pluralize from 'pluralize';

class ChurchSelector extends Component {
  get churchPicker() {
    return (
      <Menu onClick={this.selectChurch}>
        {
          this.props.churches.map((church) => {
            return (
              <Menu.Item key={`church_id_${church.id}`} churchId={church.id}>
                {this.getChurchTitle(church)}
              </Menu.Item>
            );
          })
        }
      </Menu>
    );
  }

  get revivalInfoBlock() {
    switch(this.props.selectedChurch.revival.phase) {
      case 0:
        return <span>Before Event</span>;
      case 1:
        const daysCount = revivalPhaseCountdown(this.props.selectedChurch.revival);
        return (
          <span>
            <span className="stress">Preparation</span> - {pluralize('Day', daysCount, true)} to Event
          </span>
        );
      case 2:
        return (
          <span>
            <span className="stress">Day {this.props.selectedChurch.revival.phaseDayNumber}</span> of Event
          </span>
        );
      case 3:
        return (
          <span>
            <span className="stress">Day {this.props.selectedChurch.revival.phaseDayNumber}</span> of Non Event mode
          </span>
        );
    }
  }

  getChurchTitle(church) {
    return (
      <span className="church-selector__selector-group">
        <span className="church-selector__church-name stress">{church.name} </span>
        <span className="church-selector__church-code">({church.code})</span>
      </span>
    );
  }

  selectChurch = (event) => {
    const newLocation = this.props.location.pathname.replace(/dashboard\/.*?\//,
                                                             `dashboard/${event.item.props.churchId}/`);
    this.props.history.push(newLocation);
  };

  render() {
    return (
      <div className="dashboard-header__church-selector">
        <div className="selector">
          <Dropdown overlay={this.churchPicker} trigger={['click']} disabled={this.props.disabled}>
            <a className="ant-dropdown-link" href="#">
              {this.getChurchTitle(this.props.selectedChurch)} {this.props.disabled || <Icon type="down" />}
            </a>
          </Dropdown>
        </div>
        <div className="divider">|</div>
        <div className="revival-info-block">{this.revivalInfoBlock}</div>
        <div className="divider">|</div>
        <Link to={`/dashboard/${this.props.selectedChurch.id}/churchProfile/event`}>
          <Button type="default" size="small">Event</Button>
        </Link>
      </div>
    );
  }
}

export default withRouter(ChurchSelector);



// WEBPACK FOOTER //
// ./src/components/churchSelector/churchSelector.js